import { ChangeEvent, useState } from "react";
import { TSpeakerContent } from "../../../../../../../services/api/instances/meetingsApi/types";
import { AppMarkdownParser } from "../../../../../../../shared/components/AppMarkdownParser";
import { AppInput } from "../../../../../../../shared/components/AppInput";
import { TranscriptActions } from "../TranscriptActions";
import { TSpeechActions } from "../../../../../types";
import { SpeakerSelection } from "../SpeakerSelection";
import { SPEAKER_UNDEFINED } from "../../../../../constants";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";

interface Props {
  speakers: Omit<TSpeakerContent, "speech_content" | "isActive">[];
  speaker: TSpeakerContent;
  handleActions: (id: string, type: TSpeechActions) => void;
  onSelectSpeaker: (
    speaker: Omit<TSpeakerContent, "speech_content" | "isActive"> | null,
    id: string,
  ) => void;
  onSpeechChange: (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    id: string,
  ) => void;
  className?: string;
}

export const SpeechEditor = ({
  speaker,
  speakers,
  handleActions,
  onSelectSpeaker,
  onSpeechChange,
  className,
}: Props) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <div className={styles["speech-item"]}>
      <div className={styles["speech-header"]}>
        <SpeakerSelection
          speaker={speaker}
          speakers={speakers}
          onSelectSpeaker={(item) => onSelectSpeaker(item, speaker.id)}
        />
        <TranscriptActions
          speechItemId={speaker.id}
          handleAction={handleActions}
          handleEditMode={() => setIsEditMode(!isEditMode)}
        />
      </div>
      <div className={styles["speech-box"]}>
        {isEditMode || speaker.speaker_group_key === SPEAKER_UNDEFINED ? (
          <AppInput
            value={speaker.speech_content}
            multiline
            onChange={(e) => onSpeechChange(e, speaker.id)}
            className={styles["speech-edit-input"]}
          />
        ) : (
          <AppMarkdownParser
            content={speaker?.speech_content ?? ""}
            className={styles["speech"]}
          />
        )}
      </div>
    </div>
  );
};
